import React, { Component } from 'react';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';

import segmentStatus from 'propTypes/segmentStatus';
import coord from 'propTypes/coord';

import SegmentPath from '../SegmentPath';
import SegmentTooltip from '../SegmentTooltip';

export default class Segment extends Component {
  static propTypes = {
    onSelect: func.isRequired,
    onEnter: func.isRequired,
    onLeave: func.isRequired,
    isActive: bool.isRequired,
    isSelected: bool,
    priority: number,
    segment: shape({
      id: string,
      path: arrayOf(coord),
      liveTravelTime: number.isRequired,
      status: segmentStatus.isRequired,
    }).isRequired,
  };

  defaultProps = {
    priority: 0,
  };

  shouldComponentUpdate(newProps) {
    if (newProps.isActive !== this.props.isActive) {
      return true;
    }
    if (newProps.isSelected !== this.props.isSelected) {
      return true;
    }
    if (newProps.priority !== this.props.priority) {
      return true;
    }
    if (newProps.segment.id !== this.props.segment.id) {
      return true;
    }
    if (newProps.segment.status !== this.props.segment.status) {
      return true;
    }
    // Not the most reliable way of determining path change, but definitely the fastest
    if (newProps.segment.path.length !== this.props.segment.path.length) {
      return true;
    }
    return false;
  }

  render() {
    // eslint-disable-next-line global-require
    const PriorityFeatureGroup = require('components/Map/MapComponents/PriorityFeatureGroup')
      .default;

    const { segment, onEnter, onLeave, onSelect, isActive, isSelected } = this.props;
    const { id, from: { name: fromName }, to: { name: toName }, path, status } = segment;
    const name = { from: fromName, to: toName };

    return (
      <PriorityFeatureGroup
        key={`Segment-${id}-${status}${isActive || isSelected ? '-active' : ''}`}
        onMouseover={onEnter}
        onMouseout={onLeave}
        onClick={onSelect}
        priority={this.props.priority}
      >
        <SegmentPath
          latLngList={path}
          isDisconnected={status === 'disconnected'}
          isSelected={isSelected}
          isActive={isActive}
        />
        <SegmentTooltip name={name} status="disconnected" />
      </PriorityFeatureGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Map/CreateRoute/Segment/index.js